module.exports = __webpack_public_path__ + "static/Giant_Hill-bc65453cc52941737778701ff6028ddc.jpg";